import { render, staticRenderFns } from "./JourneyRoute.vue?vue&type=template&id=47c1b5a7&scoped=true&"
import script from "./JourneyRoute.vue?vue&type=script&lang=js&"
export * from "./JourneyRoute.vue?vue&type=script&lang=js&"
import style0 from "./JourneyRoute.vue?vue&type=style&index=0&id=47c1b5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1b5a7",
  null
  
)

export default component.exports